import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  generalInfo: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    paddingRight: '24px',
    fontSize: '13px',

    '& .eventTitle': {
      ...mixins.longText,
      margin: 0,
      maxWidth: '100%',
      fontSize: '24px',
      lineHeight: '31px',

      '@media screen and (min-width: 1441px)': {
        fontSize: '40px',
        lineHeight: '52px',
      },
    },

    '@media screen and (min-width: 1441px)': {
      gap: '24px',
      paddingRight: '32px',
      fontSize: '16px',
    },
  },
}));

export default useStyles;
